<template>
    <div class="container bg-light mt-5">
        <div class="row" style="padding: 20px 0;">
            <div class="col-md-6 col-12">
            	<p>Blog post in hungarian</p>
            	<div class="form-row">
            		<div id="a-1" class="form-group col-12 form-item--with-scaling-label form-item" :class='editPost ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Title</label>
					    <input type="text" id="titleHU" v-on:blur="removeLabelClass" class="form-control" v-model="titleHU" autocomplete="off" v-on:change="setLink($event.target.value, 'HU')">
					</div>
					<div id="b-1" class="form-group col-12 form-item--with-scaling-label form-item" :class='editPost ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Link</label>
					    <input type="text" id="linkHU" v-on:blur="removeLabelClass" class="form-control" v-model="linkHU" autocomplete="off">
					</div>
					<div id="c-1" class="form-group col-12 form-item--with-scaling-label form-item" :class='editPost ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Intro</label>
					    <textarea id="introHU" v-on:blur="removeLabelClass" class="form-control" v-model="introHU" autocomplete="off" rows="7" style="height: 90px;"></textarea>
					</div>
					<div class="form-group col-md-12">
						<label for="">More info</label>
						<Editor id="textHU" v-model="textHU"></Editor>
					</div>
            	</div>
            </div>
            <div class="col-md-6 col-12">
            	<p>Blog post in english</p>
            	<div class="form-row">
            		<div id="a-2" class="form-group col-12 form-item--with-scaling-label form-item" :class='editPost ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Title</label>
					    <input type="text" id="titleEN" v-on:blur="removeLabelClass" class="form-control" v-model="titleEN" autocomplete="off" v-on:change="setLink($event.target.value, 'EN')">
					</div>
					<div id="b-2" class="form-group col-12 form-item--with-scaling-label form-item" :class='editPost ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Link</label>
					    <input type="text" id="linkEN" v-on:blur="removeLabelClass" class="form-control" v-model="linkEN" autocomplete="off">
					</div>
					<div id="c-2" class="form-group col-12 form-item--with-scaling-label form-item" :class='editPost ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Intro</label>
					    <textarea id="introEN" v-on:blur="removeLabelClass" class="form-control" v-model="introEN" autocomplete="off" rows="7" style="height: 90px;"></textarea>
					</div>
					<div class="form-group col-md-12">
						<label for="">More info</label>
						<Editor id="textEN" v-model="textEN"></Editor>
					</div>
            	</div>
            </div>
            <div class="col-12">
            	<div class="row">
	            	<div class="form-group col-md-3 position-relative">
				  		<label for="img">Select image:</label>
						<input class="position-absolute" type="file" id="img" name="img" multiple accept="image/*" v-on:change="set_filename()">
						<p class="fileName form-control">Click for images</p>
				  	</div>
				  	<div class="form-group col-md-8 align-items-center d-flex">
						<span v-for="(item, index) in img_file_names" v-bind:key="index">{{item}}&nbsp;/</span>
					</div>
					<div class="form-group col-md-6">
				    	<div class="form-check mt-2">
				      		<input class="form-check-input" type="checkbox" id="visible-check" v-model="visible">
			      			<label class="form-check-label" for="gridCheck">
			        			Is this article visible?
			      			</label>
			    		</div>
				  	</div>
				</div>
				<div class="text-center">
				  	<button type="submit" v-if="!editPost" v-on:click="sendDataToDB" class="btn bg-dark upload-btn text-white">Upload!</button>
				  	<button type="button" v-if="editPost" v-on:click="updateDataInDB(editPost_id)" class="btn bg-dark upload-btn text-white">Edit!</button>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
	import Compressor from 'compressorjs';
	import Editor from './Editor.vue'
	import { Bus }  from "../bus.js";
	import firebase from 'firebase';
	import { convertToLink, getCurrentDate } from '../functions.js';

    export default{
    	components: { Editor },
    	data: function () {
      		return {
	      		database : firebase.database(),
	      		storageRef : firebase.storage().ref(),
	      		editPost: false,
	      		editPost_id: "",
	      		titleHU: "",
	      		titleEN: "",
	      		introHU: "",
	      		introEN: "",
	      		linkHU : "",
			    linkEN: "",
			    textHU: "",
			    textEN: "",
			    img_file_names: [],
			    img_file: null,
			    visible: false
	    	}
	  	},
	  	mounted: function(){
	  		var self = this;
	    	Bus.$on("post", (id) => {
	    		console.log(id);
				if(id){
					self.editPost = true;
					self.editPost_id = id;
					self.getDataFromDB(id);
				}else{
					self.editPost = false;
				}
			});
	  	},
	  	watch: {
            textHU: function (val) {
                this.textHU = val.replace("<p><br></p>", "");
            },
            textEN: function (val) {
                this.textEN = val.replace("<p><br></p>", "");
            }
        },
	  	methods: {
	  		addLabelClass: function(event){
	  			let selector = event.target.parentNode.id;
	  			document.getElementById(selector).classList.add("form-item--input-filled");
	  		},
	  		removeLabelClass: function(event){
	  			let selector = event.target.parentNode.id;
	  			let input_value = event.target.value;

	  			if(input_value === '') {
			        document.getElementById(selector).classList.remove("form-item--input-filled");
			    }
	  		},
	  		setLink: function(linkName, lang){
	  			linkName = convertToLink(linkName);

	  			if(lang == "HU"){
                	this.linkHU = linkName;
                }else{
                	this.linkEN = linkName;
                }
	  		},
	  		set_filename: function(e){
  				//let img = document.getElementById("img").value;
    			//let part = img.split("\\");
	    		//this.img_file = part[2];
	    		this.img_file = event.target.files;
	    		this.img_file_names = [];
	    		for (var i = 0; i < event.target.files.length; i++) {
			      	this.img_file_names.push(event.target.files[i].name);
			    }
	    		
	  		},
	  		updateDataInDB: function(id){
	  			let date = getCurrentDate();

	  			this.database.ref('news/' + id).update({
	    			modified: date,
				    titleHU: this.titleHU,
				    titleEN: this.titleEN,
				    linkHU : this.linkHU,
				    linkEN: this.linkEN,
				    introHU: this.introHU,
				    introEN: this.introEN,
				    textHU: this.textHU,
				    textEN: this.textEN,
				    img: this.img_file_names,
				    visible: this.visible,
				});

				alert("A cikk módosult!");

	  		},
	  		sendImgToDB: function(file){
	  			var self = this;
				new Compressor(file, {
				    quality: 0.6,
				    success(result) {
				      	self.storageRef.child("img/"+result.name).put(result).then(function(snapshot) {
						  	console.log('File uploaded!');
						});
				    },
				    error(err) {
				      	console.log(err.message);
				    },
				});
	  		},
	    	sendDataToDB: function(e){
	    		e.preventDefault();

	    		let id = Math.floor((Math.random() * 99999) + 1);
	    		let date = getCurrentDate();

	    		if(this.img_file.length != 0){
	    			for (let i = 0; i < this.img_file.length; i++) {
	    				console.log(this.img_file[i], this.img_file[i].name);
				        this.sendImgToDB(this.img_file[i]);
				    }
				}

	    		this.database.ref('news/' + id).set({
	    			date: date,
	    			modified: null,
				    titleHU: this.titleHU,
				    titleEN: this.titleEN,
				    linkHU : this.linkHU,
				    linkEN: this.linkEN,
				    introHU: this.introHU,
				    introEN: this.introEN,
				    textHU: this.textHU,
				    textEN: this.textEN,
				    img: this.img_file_names,
				    visible: this.visible,
				});

				this.titleHU = "";
	      		this.titleEN = "";
	      		this.introHU = "";
	      		this.introEN = "";
	      		this.linkHU  = "";
			    this.linkEN = "";
			    this.textHU = "";
			    this.textEN = "";
			    this.img_file_names = [];
			    this.img_file = null;
	    	},
	    	getDataFromDB: function(id){
	    		let ref = this.database.ref("news/"+id);

	    		let self = this;
	    		ref.on('value', function(snapshot) {
                	self.titleHU = snapshot.val().titleHU;
                    self.titleEN = snapshot.val().titleEN;
                    self.introHU = snapshot.val().introHU;
                    self.introEN = snapshot.val().introEN;
                    self.linkHU = snapshot.val().linkHU;
                    self.linkEN = snapshot.val().linkEN;
                    self.textHU = snapshot.val().textHU;
                    self.textEN = snapshot.val().textEN;
                    self.img_file_names = snapshot.val().img;
                    self.visible = snapshot.val().visible;
                });
	    	}
	  	}
    };
</script>


// WEBPACK FOOTER //
// src/components/NewArticle.vue